
import { Injectable, Output, Input, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataModel, IDataModel } from './data.model';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { TextSearch } from "../comum/textSearch";
import { UsersService } from './usuarios.service';

const tab = 'produtosComentarios';

export interface IProdutoComentario extends IDataModel {
    codigo?: string,
    fornecedor?: number,
    titulo?: string,
    usuario?: string,
    usuarioId?: string,
    mensagem?: string,
    data?: Date,
    gostei?: number,
    search?: any,
}

@Injectable()
export class ProdutoComentarios extends DataModel<IProdutoComentario> {
    private fFornecedor: number = 0;
    @Input()
    codigo: string = "";
    @Input()
    limit: number = 20;
    @Input()
    get fornecedor() {
        return this.fFornecedor;
    }
    set fornecedor(x: number) {
        if (this.fFornecedor != x) {
            this.fFornecedor = Number(x);
            //this.fetch();
        }
    }

    constructor(private db: AngularFirestore, private AFornecedor: number = 0,
        private ACodigo: string,
        private users: UsersService) {
        super(db, tab);
        this.fVerInativo = false;
        this.fornecedor = AFornecedor;
        this.codigo = ACodigo;
    }
    @Input()
    set verInativo(x) {
        this.fVerInativo = x;
        this.snapshotChanges();
    }
    where(ref) {
        console.log(this.fornecedor, this.codigo);
        if (this.codigo != "") {
            return ref.where('fornecedor', '==', this.fFornecedor)
                .where('inativo', '==', this.fVerInativo)
                .where('codigo', "==", this.codigo)
                .limit(this.limit);
        }
    }
    snapshotChanges(proc?) {
        if (this.codigo != "") {
            this.reset(
                r => {
                    return this.where(r)
                }
            );
            return super.snapshotChanges(proc);
        }
    }
    searchAggr(item) {
        return item.titulo;
    }
    update(id, item, proc?: any, errProc?: any) {
        if (item.titulo)
           item.search = TextSearch.decode(this.searchAggr(item));
        return super.update(id, item, proc, errProc);
    }

    add(item) {
        item.usuario = this.users.usuario.nome;
        item.email = this.users.usuario.email;
        item.usuarioId = this.users.usuario.id;
        item.data = new Date();
        item.fornecedor = this.fFornecedor;
        item.codigo = this.codigo;
        if (item.titulo)
            item.search = TextSearch.decode(this.searchAggr(item));
        return super.add(item);
    }

    searchWhere(w: any, texto: string) {
        TextSearch.encodeWhere(w, 'search.', texto);
    }

    getComentarios(fornecedor: number, codigo: string, proc?) {
        console.log(fornecedor, codigo);
        if (codigo > '') {
            this.fornecedor = fornecedor;
            this.codigo = codigo;
            this.snapshot(
                r => {
                    return r.where("fornecedor", "==", fornecedor)
                        .where("codigo", "==", codigo).orderBy('data', 'desc').limit(10);
                }
                ,
                proc
            );
        }
    }
    
    getComentariosAbertos(fornecedor: number, proc?) {
        let qry = new ProdutoComentarios(this.db,0,'',this.users);
        qry.fornecedor = fornecedor;
        console.log(fornecedor);
        if (fornecedor > 0) {
            qry.snapshot(
                r => {
                    return r.where("fornecedor", "==", fornecedor)
                        .where("finalizado", "==", false).orderBy('data', 'desc').limit(20);
                }
              ,proc  
            );
        }
    }
 
    gostei(coment) {
        if (coment.gostei)
          coment.gostei ++
        else coment.gostei = 1;  
        this.update(coment.id,{gostei:coment.gostei});
    }
    arquivar(coment) {
        this.update(coment.id,{finalizado:true});
    }
}
